































import {Component, Prop, PropSync, Vue, Emit} from 'vue-property-decorator'
import {
  DxNumberBox
} from 'devextreme-vue/ui/number-box';
import {
  DxValidator,
  DxRequiredRule,
  DxEmailRule,
  DxStringLengthRule
} from 'devextreme-vue/validator';

@Component({
  name: 'DNumberbox',
  components: {
    DxNumberBox,
    DxValidator,
    DxRequiredRule,
    DxEmailRule,
    DxStringLengthRule
  }
})
export default class extends Vue {

  @PropSync('inputData') public synceInputData!: number;
  @Prop({ default: '' }) public title!: string;
  @Prop({ default: false }) public isRequired!: boolean;
  @Prop({ default: false }) public isReadOnly!: boolean;
  @Prop() public min: number;
  @Prop() public max: number;
  @Prop() public tabIndex: number;
  @Prop() public disabled: boolean;
  @Prop() public format: any;
  // Убирает нижнее подчеркивание для селектбоксов
  @Prop({default: false}) public hideUnderLine!: boolean;
  @Prop({default: false}) public hidePadding!: boolean;
  @Prop({default: false}) public totalBlock!: boolean;
  @Prop({default: 1}) public step!: number;
  @Prop({}) public elementAttr!: any;
  // Добавляем поддержку вставки Excel
  @Prop({default: false}) public enableExcelPaste!: boolean;
  @Prop() public cellData!: any;

  created() {
  }

  @Emit("focusIn")
  focusIn(e:any) {
    // Если включена поддержка вставки Excel, эмитим событие с данными ячейки
    if (this.enableExcelPaste && this.cellData) {
      this.$emit('cellFocus', this.cellData);
    }
    return e;
  }

  @Emit("focusOut")
  focusOut(e:any) {
    return e;
  }

  @Emit("contentReady")
  contentReady(e:any) {
    return e;
  }

  @Emit("paste")
  paste(e:any) {
    // Если включена поддержка вставки Excel, обрабатываем событие вставки
    if (this.enableExcelPaste) {
      console.log('📋 DNumberbox paste event, emitting excelPaste');
      console.log('📋 Original event:', e);
      // Передаем оригинальное событие, если оно есть
      const eventToEmit = e.event.originalEvent || e;
      this.$emit('excelPaste', eventToEmit);
    }
    return e;
  }

  @Emit("afterChange")
  onChange(e:any) {
    return e;
  }

  onValueChanged(e:any) {
    // this.synceInputData = e.value;
    console.log("DNumberbox value changed:", e.value);
    this.$emit('update:synceInputData', this.synceInputData)
    this.$emit('afterChange', e);
  }

  @Emit("enterKey")
  onEnterKey(e:any) {
    return e;
  }

  @Emit("cellFocus")
  onCellFocus(cellData: any) {
    return cellData;
  }

  @Emit("excelPaste")
  onExcelPaste(event: ClipboardEvent) {
    return event;
  }

}
